<template>
  <div @click="toPayPanel()" :class="`bottom-btn ${h5ConfigDetails[0]['bottomBtnSet']['bottomBtnIsFix'][0] == 1 ? 'fix-bottom' : ''}`" :style="{order:h5ConfigDetails[0]['modalOrder']['BottomBtnOrder'][0]}">
    <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['bottomBtnImg']['bottomBuyBtn'][0]}`" alt="">
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'

export default {
  name: 'BottomBtn',
  data () {
    return {
      baseUrl,
    }
  },
  components: {
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath'])
  },
  created () {
  },
  mounted () {
  },
  methods: {
    toPayPanel(){
      this.$parent.$refs.payPanelBottom.show()
    }
  }
}
</script>

<style scoped lang="less">
  .bottom-btn{
    position: relative;
    font-size: 0;
    .bg{
      width: 100%;
      height: auto;
    }
  }

  .fix-bottom{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 999;
  }
</style>